import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Contenido del ActionDialog: el nombre del campo hace de label
export const ModalStyled = styled.div`
  .title-field {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${tokens.color.text.label};
  }
`
